export class ChangePasswordUtenteIN {
    desEmail: string
    newPassword: string
}
